import { createContext, useContext } from "react"

export const RiaChatContext = createContext({
  isOpen: false,
  openRia: () => {},
  closeRia: () => {},
  conversationId: null,
  setConversationId: () => {},
  prefill: "",
  setPrefill: () => {},
  hideRia: false,
  setHideRia: () => {},
})

export function useRiaChatContext() {
  return useContext(RiaChatContext)
}
